<template>
	<div class="global-list-ordered">
		<div v-for="(item, i) in data" :key="i" class="global-list-ordered__item">
			<div class="global-list-ordered__order">{{ i + 1 }}</div>
			{{ i18nService.$tDynamic('components.list', item.text) }}
			<a v-if="item.mail" :href="`mailto:${item.mail}`">
				<ButtonUnderlined class="global-list-ordered__mail">{{ $t('components.list.contact_with_us') }}</ButtonUnderlined>
			</a>
		</div>
	</div>
</template>

<script setup lang="ts">
interface GlobalListData {
	text: string
	subList?: GlobalListData[]
	mail?: string
}

defineProps<{
	data: GlobalListData[]
}>()

const i18nService = usei18nService()
</script>

<style lang="scss">
@import './Ordered';
</style>
